import React from "react";

const MenuPic = (props) => {
  const { storeId } = props;
  return (
    <div className="menupicContainer my-4">
      <h1 className="text-center">Bowinkles Menu &amp; Prices</h1>
      <div className="menuPic">
        <div className="row justify-content-center">
          <div className="col-lg-5">
            <img
              src={
                storeId === "1"
                  ? "/images/Bowinkles-Menu-riolinda-Part1.jpg"
                  : "/images/Bowinkles-Menu-rancho-Part1.jpg"
              }
              alt={"Bowinkles Menu"}
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-lg-5">
            <img
              src={
                storeId === "1"
                  ? "/images/Bowinkles-Menu-riolinda-Part2.jpg"
                  : "/images/Bowinkles-Menu-rancho-Part2.jpg"
              }
              alt={"Bowinkles Menu"}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPic;
